export const PartnerInfoUploadConfig = {
	grid: {		
		gridId:'partnerUploadGrid',
		checkbox: true,
		edit: false,
		delete: true,		
		pageSize: 100,
		groupable: true,
	},
	columns: {
		PartnerInfoKey: {
			dataName: 'PartnerInfoKey',
			type: 'string',
			title: 'PartnerInfoKey',
			width: 100,
			hidden: true,
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		Prefix: {
			class: 'value',
			dataName: 'Prefix',
			type: 'string',
			title: 'Prefix',
			width: 100,
			hidden: false,
			readOnly:false
		},
		FirstName: {
			class: 'value',
			dataName: 'FirstName',
			type: 'string',
			title: 'First Name',
			width: 150,
			hidden: false,
			readOnly:false
		},
		MiddleName: {
			class: 'value',
			dataName: 'MiddleName',
			type: 'string',
			title: 'Middle Name',
			width: 150,
			hidden: false,
			readOnly:false
		},
		LastName: {
			class: 'value',
			dataName: 'LastName',
			type: 'string',
			title: 'Last Name',
			width: 150,
			hidden: false,
			readOnly:false
		},
		Suffix: {
			class: 'value',
			dataName: 'Suffix',
			type: 'string',
			title: 'Suffix',
			width: 100,
			hidden: false,
			readOnly:false
		},
		EntityName: {
			class: 'value',
			dataName: 'EntityName',
			type: 'string',
			title: 'Entity Name',
			width: 150,
			hidden: false,
			readOnly:false
		},
		FullName: {
			class: 'value',
			dataName: 'FullName',
			type: 'string',
			title: 'Partner Name',
			width: 150,
			hidden: false,
			readOnly:false
		},
		ReceiveFMV: {
			class: 'choice',
			dataName: 'ReceiveFMV',
			type: 'string',
			title: 'Receive FMV',
			width: 150,
			hidden: false,
			readOnly:false
		},
		VestingAcceleration:{
			class: 'choice',
			dataName: 'VestingAcceleration',
			type: 'string',
			title: 'Vesting Acceleration',
			width: 200,
			hidden: false,
			readOnly:false
		},
		HireDate: {
			class: 'value',
			dataName: 'HireDate',
			type: 'date',
			title: 'Hire Date',
			width: 120,
			hidden: false,
			readOnly:false
		},
		LeaveDate: {
			class: 'value',
			dataName: 'LeaveDate',
			type: 'date',
			title: 'Termination Date',
			width: 170,
			hidden: false,
			readOnly:false
		},
		TaxId: {
			class: 'value',
			dataName: 'TaxId',
			type: 'string',
			title: 'Tax Id',
			width: 100,
			hidden: false,
			readOnly:false
		},
		TSDocId: {
			class: 'value',
			dataName: 'TSDocId',
			type: 'string',
			title: 'TS Document Id',
			width: 170,
			hidden: false,
			readOnly:false
		},
		PartnerStatus: {
			class: 'choice',
			dataName: 'PartnerStatus',
			type: 'string',
			title: 'Partner Status',
			width: 170,
			hidden: false,
			readOnly:false
		},
		Position:{
			class: 'choice',
			dataName: 'Position',
			type: 'string',
			title: 'Position',
			width: 150,
			hidden: false,
			readOnly:false
		},
		Domestic: {
			class: 'choice',
			dataName: 'Domestic',
			type: 'string',
			title: 'US Status',
			width: 150,
			hidden: false,
			readOnly:false
		},
		DocumentDeliveryMethod : {
			class: 'choice',
			dataName: 'DocumentDeliveryMethod',
			type: 'string',
			title: 'Document Delivery Method',
			width: 200,
			hidden: false,
			readOnly:false
		},
		EMail:{
			class: 'value',
			dataName: 'EMail',
			type: 'string',
			title: 'EMail',
			width: 250,
			hidden: false,
			readOnly:false
		},
		Address1: {
			class: 'value',
			dataName: 'Address1',
			type: 'string',
			title: 'Address Line1',
			width: 200,
			hidden: false,
			readOnly:false
		},
		Address2: {
			class: 'value',
			dataName: 'Address2',
			type: 'string',
			title: 'Address Line2',
			width: 180,
			hidden: false,
			readOnly:false
		},
		City: {
			class: 'value',
			dataName: 'City',
			type: 'string',
			title: 'City',
			width: 100,
			hidden: false,
			readOnly:false
		},
		State: {
			class: 'value',
			dataName: 'State',
			type: 'string',
			title: 'State',
			width: 100,
			hidden: false,
			readOnly:false
		},
		PostalCode: {
			class: 'value',
			dataName: 'PostalCode',
			type: 'string',
			title: 'Postal Code',
			width: 150,
			hidden: false,
			readOnly:false
		},
		Country: {
			class: 'value',
			dataName: 'Country',
			type: 'string',
			title: 'Country',
			width: 100,
			hidden: false,
			readOnly:false
		},
		CheckMailAddress : {
			class: 'value',
			dataName: 'CheckMailAddress',
			type: 'string',
			title: 'Mail Address Same as Registered Address',
			width: 250,
			hidden: false,
			readOnly:false
		},
		MailAddress1: {
			class: 'value',
			dataName: 'MailAddress1',
			type: 'string',
			title: 'Mail Address Line1',
			width: 220,
			hidden: false,
			readOnly:false
		},
		MailAddress2: {
			class: 'value',
			dataName: 'MailAddress2',
			type: 'string',
			title: 'Mail Address Line2',
			width: 220,
			hidden: false,
			readOnly:false,
		},
		MailCity: {
			class: 'value',
			dataName: 'MailCity',
			type: 'string',
			title: 'Mail City',
			width: 120,
			hidden: false,
			readOnly:false
		},
		MailState: {
			class: 'value',
			dataName: 'MailState',
			type: 'string',
			title: 'Mail State',
			width: 130,
			hidden: false,
			readOnly:false
		},
		MailPostalCode: {
			class: 'value',
			dataName: 'MailPostalCode',
			type: 'string',
			title: 'Mail Postal Code',
			width: 180,
			hidden: false,
			readOnly:false
		},
		MailCountry: {
			class: 'value',
			dataName: 'MailCountry',
			type: 'string',
			title: 'Mail Country',
			width: 170,
			hidden: false,
			readOnly:false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Comments',
			width: 150,
			hidden: false,
			readOnly:false
		},
		MemoGroup:{
			class: 'choice',
			dataName: 'MemoGroup',
			type: 'string',
			title: 'Memo Group',
			width: 150,
			hidden: false,
			readOnly:false
		}
	}
}